// Native
import { Flex, Spinner, useColorMode } from '@chakra-ui/react'
import { Moment } from 'config'
import { useReport } from 'hooks'
import Apex from 'react-apexcharts'

export default function WithdrawsByStatusBarChart({ period, ...props}){
    
    const { colorMode } = useColorMode()
    const report = useReport('withdraws_by_status', period)

    const series = [{ name: 'Pedidos de saque', data: report.data?.data?.map(item => item.total) ?? []}]

    const options = {
        theme: {
            mode: colorMode
        },
        title: {
            text: 'Pedidos de saque por status (Período)',
            align: 'center'
        },
        subtitle: {
            text: `${Moment(report.data?.metadata?.starts).format('DD/MM/YYYY')} até ${Moment(report.data?.metadata?.ends).format('DD/MM/YYYY')}`,
            align: 'center'
        },
        chart: {
            type: 'bar',
            height: 350,
            background: 'transparent'
        },
        grid: {
            show: false
        },
        plotOptions: {
            bar: {
                borderWidth: 0,
                borderRadius: 4,
                borderRadiusApplication: 'end',
                horizontal: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: report.data?.data?.map(item => item.status) ?? [],
            labels: {
                show: true,
            },
        },
        yaxis: {
            labels: {
                show: false,
            },
        },
        colors: ['#FFFFFF', '#800000', 'green']
    }
    
    // Loading state
    if(report.isLoading) return <Flex w="100%" h={350} alignItems="center" justifyContent="center"><Spinner /></Flex>

    return <Apex options={options} series={series} type="bar" height={350} />
}